export const ASSET_SEARCH_FIELDS = [
    { key: "tag", label: "Tag" },
    { key: "description", label: "Description" },
    { key: "type", label: "Type" },
    { key: "assetType", label: "Asset Type" },
    { key: "system", label: "System" },
    { key: "manufacturer", label: "Manufacturer" },
    { key: "model", label: "Model" },
    { key: "sfg20Code", label: "SFG20 Code" },
    { key: "importedFrom", label: "Imported From" },
]

export const ASSET_SEARCH_FIELDS_LABEL = ASSET_SEARCH_FIELDS.map(({ label }) => label).join(", ")
